/**Tabla de configuración del sistema. Esta tabla siempre tiene solo una fila */
export interface ConfigSistema {

    IdRegistro: number;

    /**Tasas globales de los impuestos */
    TasaImpuestos: TasaImpuestos;

    /**Tasas globales de los impuestos */
    ConfiguracionEmpresa: ConfiguracionEmpresa;

    ConfiguracionEmpresaLogistica: ConfiguracionEmpresa

    IdClienteConfigPaqueteria: number | null;
    IdClienteConfigLogistica: number | null;

    /**
     * Divisor que se utiliza en la fórmula para obtener el peso volumetrico de una guia. La formula es max(peso, volumen / divisor) donde el peso es en kg
     * y el volumen en cm3
     */
    DivisorPesoVolumetrico: number;

    /**
     * Para los pares de sucursales que no esten capturados en la matriz de distancias, tomar esta distancias. Si no se establece se lanzarán excepciones cuando se requiera obtener
     * la distancias entre las sucursales no capturadas
     */
    DistanciaParaParesNoCapturados: number | null;

    /**Tarifa general del sistema, esta aplica para todos los clientes que no tienen convenio */
    IdTarifa: number;

    IdArticuloFleteLogistica: number | null;

    /**Articulo de facturación que corresponde a la venta de una guia */
    IdArticuloGuia: number;

    /**Articulo de facturación que corresponde a la venta de una guía de PP */
    IdArticuloGuiaPP: number;

    /**Articulo de facturación que corresponde al concepto */
    IdArticuloConceptoDeNotaDeCredito: number;

    /**Articulo de facturación que corresponde al concepto de REP */
    IdArticuloConceptoDeREP: number;

    /**Colonia de la dirección de la empresa */
    IdColonia: number;

    IdColoniaLogistica: number;

    /**Id del contenido de sobre que se usa en las guias de acuse */
    IdContenidoSobreAcuse: number;

    /**Tiempo de mantenimiento de los clientes (Cantidad de meses) */
    TiempoMantenimiento: number;

    /**Es el factor aplicado según el tiempo mantenimiento */
    FactorTiempoMantenimiento: number;

    /**Factor máximo de descuento para comision */
    FactorMaximoDescuento: number;

    /**La comisión si el fescuento supera el factor maximo */
    ComisionDescuentoSuperaFactor: number;

    /**La comisión si el fescuento no supera el factor maximo */
    ComisionDescuentoNoSuperaFactor: number;

    /**Configuración de las cuentas contables */
    Contabilidad: ConfigContabilidad;

    ContabilidadLogistica: ConfigContabilidad;

    /**Configuración para la conexión con el sistema de eco horu */
    ConexionContabilidad: ConexionSistemaContabilidad;
    
    ConexionContabilidadLogistica: ConexionSistemaContabilidad;

    /**RFC genérico para la factura de público general */
    RfcReceptorFacturaPublicoGeneral: string;

    /**Clave de producto para los conceptos de las notas de crédito */
    IdProductoSATConceptoNotaCredito: number;

    /**Clave de producto para los conceptos de REP */
    IdProductoSATConceptoREP: number;

    /**Clave de la unidad para los conceptos de las notas de crédito */
    IdUnidadSATConceptoNotaCredito: number;

    /**Clave de la unidad para los conceptos de REP */
    IdUnidadSATConceptoREP: number;

    /**archivo .apk que contiene la aplicación de android */
    //Apk: string;

    /**Nombre de archivo apk .apk con extensión */
    //NombreApkConExtension: string;

    /**configuración de envío de correo */
    ConfiguracionCorreo: ConfiguracionCorreo;

    /**configuración de envío de correo */
    ConfiguracionCorreoGuias: ConfiguracionCorreo;

    /**True para mostrar la configuración del sistema de pruebas */
    EsDePruebas: boolean;

    /**Representa el tiempo máximo (segundos) en que el sistema permite estar a los usuarios sin actividad después de esté tiempo cierra la sesión */
    LimiteInactividad: number;

    /**Es el dominio del sistema */
    Dominio: string;

    /**Es el id de la ultima guía que se buscará para los views de status del sistema */
    IdGuiaLimiteStatus: number;

    /**Es el id de la ultima documentación que se buscará para los views de limites del sistema */
    IdDocumentacionLimiteStatus: number;

    /**Es el texto que se muestra en la sección de aviso de privacidad, este texto debe estar en formado markdown */
    AvisoPrivacidadTexto: string;

    ImporteGastoAdministrativo: number;

    CondicionesGeneralesContrato: string;

    HabilitarValidacionesCartaPorte: boolean;

    HabilitarTimbradoCartaPorte: boolean;


    /**Dirección de la sucursal */
    DireccionLogistica: Direccion;

    /**Certificado .cer */
    CertificadoLogistica: string;

    /**Nombre de archivo certificado .cer con extensión */
    NombreCertificadoConExtensionLogistica: string;

    /**llave .key */
    LlaveLogistica: string;

    /**Nombre de archivo llave .key con extensión */
    NombreLlaveConExtensionLogistica: string;

    /**Contraseña de la llave */
    ContraseñaLlaveLogistica: string;


    ///----------------------------------------------------------------

    CertificadoModoPruebas: string;
    NombreCertificadoConExtensionModoPruebas: string;
    LlaveModoPruebas: string;
    NombreLlaveConExtensionModoPruebas: string;
    ContraseñaLlaveModoPruebas: string;

    ClaveSatRegimenFiscalEmisorModoPruebas: string;
    CodigoPostalModoPruebas : string;
    NombreEmisorModoPruebas: string;
    RfcModoPruebas: string;


}

export interface ConfigSistemaDTO extends ConfigSistema {
    NombreApkConExtension: string;
    ModificoAPK: boolean;
    Apk: string;
    ModificoAviso: boolean;
    Aviso: string;
    ModificoImagenInicio: boolean;
    ImagenInicio: string | null;

    ActualizarMatriz_Aumento: boolean;
    ActualizarMatriz_Cantidad: number;
    ActualizarMatriz_Seguro: number;
    IdMatrizTarifa: number | null;
}

/**Configuracion de correo  */
export interface ConfiguracionCorreo {
    /**Cliente smtp */
    ClienteSmtp: string;

    /**Puerto smtp */
    Puerto: number;

    /**Usuario smtp */
    Usuario: string;

    /**Contraseña smtp */
    Password: string;

    /**Indica si el envío de los correos de notificación enviados tendrán activados el protocolo SSL */
    EnableSsl: boolean;
}

export interface TasaImpuestos {
    TasaIva: number;
    RetencionIvaPersonaFisica: number;
    RetencionIvaPersonaMoral: number;
}

/**Configuración de la empresa para timbrado */
export interface ConfiguracionEmpresa {

    /**Calle de la direcicón de la empresa */
    Calle: string;

    /**Teléfono de la empresa */
    Telefono: string;

    /**Nombre del emisor */
    NombreEmisor: string;

    /**RFC del emisor */
    Rfc: string;

    /**Serie de las facturas */
    SerieFacturas: string;

    /**Serie de las notas de credito */
    SerieNotaCredito: string;

    /**Serie de las notas de cargo */
    SerieNotaCargo: string;


    /**Es el tipo de cambio que se utiliza para las facturas de nota de credito */
    TipoCambioNotaCredito: number;

    /**Codigo postal  */
    CodigoPostal: string;

    /**Numero de cuenta beneficaria que se usara en la creación de nuevas facturas */
    NoCuentaBeneficiaria: string;

    /**Clave del sat para el regimen fiscal del emisor de las facturas generadas por el sistema. Este valor sale del catálogo c_RegimenFiscal del SAT */
    ClaveSatRegimenFiscalEmisor: string;

    /**Clave del sat para el uso del receptor de las facturas generadas por el sistema. Este valor sale del catálogo c_UsoCFDI del SAT */
    ClaveSatUsoReceptor: string;

    /**Clave del sat para la moneda de las facturas. Este valor sale del catálogo c_Moneda */
    ClaveSatMoneda: string;

    /**La cantidad de días que se necesita que pasen para poder facturar las guías */
    DiasParaFacturar: number;

    /**True para habilitar el modo de pruebas en el timbrado */
    ModoPruebas: boolean;

    /**
     * Si el importe asegurado de una guia es mayor a este valor, la guia se considera que tiene un seguro externo, en otro caso, se considera que tiene un seguro interno. Este tipo de seguro
     * afecta a la contabilización de la guia
     */
    LimiteSeguroInterno: number;

    /**Clave SAT de la moneda por default para las facturas manuales */
    ClaveSatMonedaManual: string;

    /**Clave SAT del regimen fiscal por default para las facturas manuales */
    ClaveSatRegimenFiscalManual: string;

    /**Clave del sat para el uso del receptor de las facturas generadas por el sistema. Este valor sale del catálogo c_UsoCFDI del SAT */
    ClaveSatUsoCFDINotaDeCredito: string;
}

export const configSistemaInicial: ConfigSistema = {
    TasaImpuestos: {
    },
    ConfiguracionEmpresa: {
    },
    ConexionContabilidad: {},
    Contabilidad: {
        DepositosBanco: {
            Contado: {}
        },
        Guias: {
            Contado: {},
            CreditoFacturado: {},
            CreditoNoFacturado: {}
        }
    }
} as any;


/**Configuración de las claves de las cuentas de contabilidad */
export interface ConfigContabilidad {
    DepositosBanco: ConfigContabilidadCuentasDepositosBanco;
    Guias: ConfigContabilidadCuentasGuias;
    NotasDeCredito: ConfigContabilidadCuentasNotaCredito;
    Reps: ConfigContabilidadRep;
    EntregaIngresos: ConfigContabilidadEntregaIngresos;
}

/**Configuración de las claves de las cuentas de contabilidad */
export interface ConfigContabilidadLogistica {
    DepositosBanco: ConfigContabilidadCuentasDepositosBanco;
    Guias: ConfigContabilidadCuentasGuias;
    NotasDeCredito: ConfigContabilidadCuentasNotaCredito;
    Reps: ConfigContabilidadRep;
    EntregaIngresos: ConfigContabilidadEntregaIngresos;
}

/**Cuentas contables para las entregas de ingresos de ZE */
export interface ConfigContabilidadEntregaIngresos {
    CargoBancos: string;
    AbonoSaldoUsuarioZE: string;
}

/**Cuentas contables para los REPs */
export interface ConfigContabilidadRep {
    CargoBancos: string;
    AbonoCliCred: string;
}

export interface ConfigContabilidadCuentasNotaCredito {
    Total: string;
    Subtotal: string;
    Iva: string;
    RetencionIva: string;

    TotalFacturasCredito: string;
    SubtotalFacturasCredito: string;
    IvaFacturasCredito: string;
    RetencionIvaFacturasCredito: string;
}

export interface ConfigContabilidadCuentasDepositosBanco {
    Contado: ConfigContabilidadCuentasDepositoBanco;
}

export interface ConfigContabilidadCuentasGuias {
    /**Cuentas para las guias pagadas de contado */
    Contado: ConfigContabilidadCuentasPagoGuia;
    /**Cuentas para las guias de crédito que ya fueron facturadas */
    CreditoFacturado: ConfigContabilidadCuentasPagoGuia;
    /**Cuentas para las guias de crédito que aún no han sido facturadas */
    CreditoNoFacturado: ConfigContabilidadCuentasPagoGuia;
}


export interface ConfigContabilidadCuentasDepositoBanco {
    CargoBanco: string;
    AbonoClientesCredito: string;
}

/**Claves de las cuentas segun el concepto del pago de una guia */
export interface ConfigContabilidadCuentasPagoGuia {
    AbonoFlete: string;
    AbonoRecoleccionDomicilio: string;
    AbonoEntregaDomicilio: string;
    AbonoSeguroInterno: string;
    AbonoSeguroExterno: string;
    AbonoAcuse: string;
    AbonoIva: string;
    AbonoMovimientosManuales: string;
    /**Representa el cobró de los valores adicionales como lo son el valor factura y el Servicio especial */
    AbonoCobrosAdicionales: string;

    CargoRetencionIva: string;
    CargoTotal: string;
    CargoServiciosEspeciales: string;

    CargoAdministrativo: string;
    ZonaExtendida: string;

    //TODO: Falta que que es eso del "Prepago" y del "Seguro externo"
}

/**Datos para la conexión con el sistema de supercontabilidad */
export interface ConexionSistemaContabilidad {
    /**Deshabilita la conexión con el sistema de contabilidad */
    Deshabilitar: boolean;
    URL: string;
    BaseDatosId: string;
    Usuario: string;
    Contraseña: string;
    /**Clave de la empresa en el sistema de contabilidad */
    ClaveEmpresa: number;
}

export interface Direccion {
    Calle: string;
    NoExterior: string;
    NoInterior?: string;
    Telefono: string;
    Email: string;
}


// WEBPACK FOOTER //
// ./app/models/configsistema.ts